import ViewBase from "../../view-base.view";
import { Button, Dialog, Intent, Tooltip, Popover, PopoverPosition } from "construct-ui";
import teamScheduleModel from "../../../models/schedule/team-schedule.model";
import ScheduleDetailsView from "./schedule-details.view";
import AssignScheduleView from "./assign-schedule.view";
import SendToJPOResultView from "./send-to-JPO-result.dialog"
import ScheduleExcelUploadView from "./schedule-excel-upload.view";
import UserBadgeComponent from "../../../components/common/user-badge.component";
import moment from "moment";
import 'CssFolder/schedule/team-schedule.scss';
import _ from "lodash";
import { codeMasterType, formats as FORMATS, ROUTE_PLAN_COLORS_SET } from '../../../config/constants';
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import workTypeModel from "../../../models/work-type/work-type.modal";
import loginModel from '../../../models/login.model';
import JPOScheduleCalendarView from "../jpo/jpo-schedule-calendar.view";
import JPOModel from "../../../models/schedule/jpo-schedule.model"

export default function TeamScheduleView() {

  ViewBase.call(this);
  const DATE_FORMAT_TABLE_HEADER = 'YYYY.MM.DD (ddd)';
  // const DATE_SEPARATOR = '   ~   ';
  const DATE_TYPE = 'DAY'; // DAY / WEEK / MONTH
  let fromDate = moment().add(-1, 'd').format(FORMATS.dateFormat);
  let toDate = moment().add(5, 'd').format(FORMATS.dateFormat);
  let dayColumns = [];
  let scheduleTable;
  let userScheduleAccess = [];
  let isOpenScheduleDetails = false;
  let isOpenScheduleExcelUpload = false;
  let isSimpleExcelUpload = false;
  let scheduleUserDetails;
  let activePopoverCol = '';
  let workTypeList = [];
  let workTypeColorList;
  let workTypeIconElementList;
  let workTypeOptionList;
  let selectedWorkTypeList = [];

  /** selectableTable - start */
  var selectableRoot;
  var selectableEls;
  var hasSelection = false;
  var isMouseDown = false;
  var firstRow = -1;
  var firstCol = -1;
  var lastCol = -1;
  var lastEl;
  let selectedDays = [];
  let selectedElIndexes = [];
  /** selectableTable - end */

  let showDetails = false;
  let selectedItem = {};

  let JPOresult = [];
  let isSendToJPO = false;
  let showSendToJPOResult = false;

  const onRoutePlanDetailsView = (schedule) => {
    const idx = Math.floor(Math.random() * 12);
    selectedItem = {
      color: ROUTE_PLAN_COLORS_SET[idx],
      userId: schedule.userID,
      scheduleDate: schedule.scheduleDate,
      userName: schedule.userName
    };
    showDetails = true;
  }

  let generateColumnsForSelectedDays = () => {

    let numberOfDays = moment(toDate, FORMATS.dateFormat).diff(moment(fromDate, FORMATS.dateFormat), 'days');
    dayColumns = [];

    for (let i = 0; i <= numberOfDays; i++) {
      dayColumns.push(moment(fromDate, FORMATS.dateFormat).add(i, 'd'));
    }
  }

  const getTeamScheduleData = () => {

    generateColumnsForSelectedDays();

    teamScheduleModel.getTeamScheduleList(
      (result) => {
        // console.log("getTeamScheduleList - result:", JSON.parse(JSON.stringify(result)));
        scheduleTable = teamScheduleModel.transformTeamScheduleObj(result.approvedSchedule, dayColumns);
        // console.log("transformed - scheduleTable:", JSON.parse(JSON.stringify(scheduleTable)));

        userScheduleAccess = result.userScheduleAccess;
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        // console.error("getTeamScheduleList - error:", JSON.parse(JSON.stringify(error)));
      },
      {
        dateType: DATE_TYPE,
        fromDate: moment(fromDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        toDate: moment(toDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        WorkTypes: selectedWorkTypeList.join('^'),
      }
    )
  }

  let getWorkListData = () => {

    workTypeModel.getWorkTypeList(
      (result) => {
        if (result && result.length > 0) {
          workTypeList = result;
        }
        workTypeModel.getWorkTypeColorList(
          (result) => {
            workTypeColorList = result;
            setWorkTypeOptionAndColorList();
            setWorkTypeIconList();
          },
          (error) => {
            this.handleError(error);
          }
        );
      },
      (error) => {
        this.handleError(error);
      }
    );

  }

  let setWorkTypeOptionAndColorList = () => {
    workTypeOptionList = [];

    workTypeList.map(wt => {
      // Create option list
      workTypeOptionList.push({ ...wt });

      // Add color info to workTypeList
      if (workTypeColorList.find(c => c.code === wt.code)) {
        wt.color = (workTypeColorList.find(c => c.code === wt.code)).name
      }
    });
  };

  let setWorkTypeIconList = () => {
    workTypeIconElementList = [];

    workTypeIconElementList.push(
      m('span', '') // Doesn't need an icon for 'Select all'
    );

    workTypeColorList.filter(e => e.code !== '000').map(e => {
      workTypeIconElementList.push(
        m('.work-type-indicator', {
          style: {
            'border-color': e.name,
            'background-color': e.name,
          }
        })
      );
    });
  }

  let getColorByWorkType = (code) => {
    const wtObj = workTypeList.find(e => e.code == code);
    if (wtObj && wtObj.color) {
      return wtObj.color;
    } else {
      return 'transparent';
    }
  }

  let reloadData = () => {
    this.showLoading();
    m.redraw(); // Callbacks from components does not trigger redraw
    getTeamScheduleData();
  }

  let setSelectedSchedule = (userId, userName, photoString, ...scheduleDates) => {
    // console.log('userScheduleAccess========>', userScheduleAccess)
    scheduleUserDetails = {};
    scheduleUserDetails.userId = userId;
    scheduleUserDetails.userName = userName;
    scheduleUserDetails.photoString = photoString;
    scheduleUserDetails.scheduleDates = scheduleDates;
    scheduleUserDetails.userAccess = userScheduleAccess.find((x) => x.userID === userId)
  }

  let showScheduleDetails = () => {
    isOpenScheduleDetails = true;
    hideAssignSchedule();
  }

  let hideScheduleDetails = () => {
    // console.log('isSendToJPO hideScheduleDetails===========>', isSendToJPO)
    if (isSendToJPO) {
      this.showMessage('There is change(s) to Schedule. Please click on the "Send to JPO" button to send the latest schedules to JPO engine.');
    } else {
      isOpenScheduleDetails = false;
    }

  }

  const getScheduleLabel = (createUserId) => {
    const labels = {
      'Online': '[Online] ',
      'JPO': '[JPO] ',
      'JPOM': '[JPOM] '
    };
    return labels[createUserId] ? m('.fw-lighter.text-muted', labels[createUserId]) : null;
  };

  // TableScheduleItem Component
  const TableScheduleItem = {
    view: (vnode) => {
      return m('.table-schedule-item.d-flex.flex-nowrap.w-100', {
        onclick: (e) => {
          // console.log('event - e', e)
          // console.log('event - e.currentTarget', e.currentTarget)
          // console.log('event - e.target', e.target)
          setSelectedSchedule(vnode.attrs.userId, vnode.attrs.userName, vnode.attrs.photoString, moment(vnode.attrs.scheduleDate).format(FORMATS.dateFormat));
          showScheduleDetails();
        }
      },
        m('.work-type-indicator', {
          style: {
            'border-color': getColorByWorkType(vnode.attrs.workType),
            'background-color': getColorByWorkType(vnode.attrs.workType),
          }
        }),
        m('.schedule-item-content',
          getScheduleLabel(vnode.attrs.createUserId),
          vnode.attrs.startTime &&
          m('.startEndTime', vnode.attrs.startEndTime),
          m('.siteName', vnode.attrs.scheduleNameDisplay),
        )
      )
    }
  }

  let isTodayOrFutureDate = (momentDate) => {
    let today = moment(moment().format(FORMATS.apiDateFormat)); // without time
    if (momentDate && moment(momentDate).isValid()) {
      return momentDate.diff(today, 'day') >= 0;
    } else {
      return false;
    }
  }

  /** selectableTable - start */
  let selectableTable = () => {

    selectableRoot = document.querySelector('table.team-schedule');

    if (!selectableRoot) {
      return
    }

    selectableEls = selectableRoot.querySelectorAll('.schedule-col.editable');

    Object.values(selectableEls).map((el, elIndex) => {

      el.onmousedown = (e) => {
        if (e.button !== 0) {
          return;
        }

        // console.log('e---------------', e)
        // console.log('e---------------target: ', e.target)
        // console.log('e---------------currentTarget: ', e.currentTarget)
        // console.log('el.querySelector(.btn-assign>bi): ', el.querySelector('.btn-assign>i'))

        // When assign button is clicked
        if (e.target.tagName === 'I') {
          return
        }

        if (hasSelection) {
          clearTableSelection();
          return;
        }

        clearTableSelection();
        let cell = e.currentTarget;
        isMouseDown = true;
        hasSelection = true;
        cell.classList.add("selected");
        selectedDays.push(dayColumns[parseInt(cell.dataset.colId)]);
        selectedElIndexes.push(elIndex);
        firstRow = parseInt(cell.dataset.rowId);
        firstCol = parseInt(cell.dataset.colId);
        lastCol = parseInt(cell.dataset.colId);
        lastEl = cell;

        // console.log('onmousedown --- e', e);
        // console.log('onmousedown --- isMouseDown', isMouseDown);
      }

      el.onmouseup = (e) => {
        if (e.button !== 0 || !isMouseDown || !hasSelection) {
          return
        }

        if (selectedDays.length === 1) {
          clearTableSelection();
          return
        }

        // reset
        isMouseDown = false;

        // let cell = e.currentTarget;
        let cell = lastEl;

        // console.log('onmouseup ------- : selectedDays', JSON.parse(JSON.stringify(selectedDays)))

        // Set information
        setSelectedSchedule(
          scheduleTable[parseInt(cell.dataset.rowId)].userID,
          scheduleTable[parseInt(cell.dataset.rowId)].userName,
          scheduleTable[parseInt(cell.dataset.rowId)].photoString,
          // dayColumns[parseInt(cell.dataset.colId)].format(FORMATS.dateFormat), // [CV] TODO: Get the array of days
          ...selectedDays.map(d => d.format(FORMATS.dateFormat))
        );

        // Open popover
        showAssignSchedule(parseInt(cell.dataset.colId), parseInt(cell.dataset.rowId));
        m.redraw();

        // console.log('onmouseup ------- activePopoverCol: ' + activePopoverCol)
        // console.log('onmouseup ------- : selectedDays', JSON.parse(JSON.stringify(selectedDays)))
        // console.log('onmouseup ------- : selectedElIndexes', JSON.parse(JSON.stringify(selectedElIndexes) ))
      }

      el.onmouseover = (e) => {
        let cell = e.currentTarget;
        if (!isMouseDown
          || !hasSelection
          || firstRow !== parseInt(cell.dataset.rowId)
          || parseInt(cell.dataset.colId) === lastCol) {
          return
        }

        // Current cell is not next to the last cell
        if (Math.abs(parseInt(cell.dataset.colId) - lastCol) > 1) {

          // console.log('onmouseover --- Current cell is not next to the last cell')

          // let distFromlastCol = Math.abs(cell.dataset.colId - lastCol);
          // let directionFromLastCol = cell.dataset.colId > lastCol ? 'right' : 'left';

          // Redraw the cell highlight here:

          // Remove all but first selection
          let removedElIndexes = selectedElIndexes.splice(1, selectedElIndexes.length - 1);
          removedElIndexes.map(i => {
            selectableEls[i].classList.remove("selected");
          })
          selectedDays.splice(1, selectedDays.length - 1);

          // Add new selections
          let distanceFromFirstCol = Math.abs(parseInt(cell.dataset.colId) - firstCol);

          for (var i = 1; i <= distanceFromFirstCol; i++) {

            if (parseInt(cell.dataset.colId) > firstCol) {
              let _elIndex = selectedElIndexes[selectedElIndexes.length - 1] + 1;
              selectedElIndexes.push(_elIndex);
              selectableEls[_elIndex].classList.add("selected");
              selectedDays.push(dayColumns[firstCol + i]);
            } else {
              let _elIndex = selectedElIndexes[selectedElIndexes.length - 1] - 1;
              selectedElIndexes.push(_elIndex);
              selectableEls[_elIndex].classList.add("selected");
              selectedDays.push(dayColumns[firstCol - i]);
            }
          }

          // console.log('onmouseover --- selectedDays - after add: ' + selectedDays.toString())

          selectedElIndexes

          lastCol = parseInt(cell.dataset.colId);
          lastEl = cell;

          return
        }

        // console.log('onmouseover --------- e: ', e);
        // console.log('onmouseover --------- firstCol: ' + firstCol);
        // console.log('            --------- lastCol: ' + lastCol + ' --> col: ' + parseInt(cell.dataset.colId));

        cell.classList.add("selected");
        if (!selectedDays.includes(dayColumns[parseInt(cell.dataset.colId)])) {
          selectedDays.push(dayColumns[parseInt(cell.dataset.colId)]);
        }
        if (!selectedElIndexes.includes(elIndex)) {
          selectedElIndexes.push(elIndex);
        }

        // Check direction
        if ((firstCol <= lastCol && lastCol < parseInt(cell.dataset.colId) && firstCol !== parseInt(cell.dataset.colId))
          || (firstCol >= lastCol && lastCol > parseInt(cell.dataset.colId) && firstCol !== parseInt(cell.dataset.colId))) {
          // Do nothing
        } else {
          // Unselect previous element
          e.fromElement.closest('.schedule-col').classList.remove("selected");
          // console.log('onmouseover -- before -- : selectedDays', JSON.parse(JSON.stringify(selectedDays)))
          // console.log('onmouseover -- before -- : selectedElIndexes', JSON.parse(JSON.stringify(selectedElIndexes)))
          selectedDays.pop();
          selectedElIndexes.pop();
          // console.log('onmouseover -- after -- : selectedDays', JSON.parse(JSON.stringify(selectedDays)))
          // console.log('onmouseover -- after -- : selectedElIndexes', JSON.parse(JSON.stringify(selectedElIndexes)))
        }

        lastCol = parseInt(cell.dataset.colId);
        lastEl = cell;

      } // end of onmouseover

    });
  }

  let clearTableSelection = () => {
    // console.log('clearTableSelection!');
    // Reset
    firstRow = -1;
    firstCol = -1;
    lastCol = -1;
    lastEl = null;
    Object.values(selectableEls).map(el => {
      el.classList.remove("selected");
    })
    selectedDays = [];
    selectedElIndexes = [];

    hasSelection = false;
    isMouseDown = false;

    // Close Popover
    hideAssignSchedule();
  }
  /** selectableTable - end */


  let showAssignSchedule = (colId, rowId) => {
    activePopoverCol = `${colId}:${rowId}`;
  }

  let hideAssignSchedule = () => {
    activePopoverCol = '';
  }

  let isAssignScheduleOpen = (colId, rowId) => {
    return activePopoverCol === `${colId}:${rowId}`;
  }

  let showScheduleExcelUpload = (simpleUpload) => {
    isOpenScheduleExcelUpload = true;
    isSimpleExcelUpload = simpleUpload;
  }

  let hideScheduleExcelUpload = () => {
    isOpenScheduleExcelUpload = false;
  }

  const handelScheduleExcelDownload = (e) => {
    e.preventDefault();
    this.showLoading();
    const dataParam = {
      fromDate: fromDate,
      toDate: toDate,
      workTypes: selectedWorkTypeList.map((x) => x.code).join('^'),
      inputUserID: loginModel.credentials.userID,
      inputCountryCode: loginModel.credentials.country,
      inputUserLanguageCode: loginModel.credentials.language
    }
    teamScheduleModel.downloadTeamScheduleExcel(dataParam)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const getBUTypes = (day) => {
    JPOModel.getSchedulePlanAndActualCodeMaster(
      (result) => {
        if (result && Array.isArray(result) && result.length > 0) {
          let currentBU = result[0].code || 'CE';
          m.route.set('/schedule/route-plan', null, {
            state: {
              date: day,
              bu: { 'code': currentBU, 'name': currentBU }
            }
          });
        } else {
          console.error('No BU returned');
        }
      },
      (error) => {
        this.handleError(error);
      },
      {
        type: codeMasterType.currentBU,
      }
    )
  }

  const getLatestJPOSchedule = () => {
    this.showLoading();
    teamScheduleModel.getLatestJPOSchedule(
      (result) => {
        // console.log("getLatestJPOSchedule - result:", JSON.parse(JSON.stringify(result)));
        // isSendToJPO = false;
        if (result && result.length > 0) {
          sendScheduleToJPO(result);
        } else {
          this.showMessage("There's no avaiable schedule to send to JPO.")
        }
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        console.error("getLatestJPOSchedule - error:", JSON.parse(JSON.stringify(error)));
      }
    )
  }

  const sendScheduleToJPO = (data) => {
    this.showLoading();
    JPOModel.manualProcessJPOSchedule((result) => {
      // console.log("getLatestJPOSchedule - result:", JSON.parse(JSON.stringify(result)));
      isSendToJPO = false;
      if (result && result.length > 0) {
        JPOresult = result;
        showSendToJPOResult = true;
        markScheduleSent(result)
      } else {
        this.showMessage("There's no avaiable schedule to send to JPO.")
      }
      this.hideLoading();
    }, (error) => {
      isSendToJPO = false;
      this.hideLoading();
      console.error("getLatestJPOSchedule - error:", JSON.parse(JSON.stringify(error)));
    }, data)
  }

  const markScheduleSent = (data) => {
    teamScheduleModel.markScheduleSent((result) => {
      // console.log("getLatestJPOSchedule - result:", JSON.parse(JSON.stringify(result)));
    }, (error) => {
      console.error("getLatestJPOSchedule - error:", JSON.parse(JSON.stringify(error)));
    }, data)
  }


  const setSendToJPO = (flag) => {
    isSendToJPO = flag;
  }

  return {
    oninit: (vnode) => {
      window.onbeforeunload = function (event) {
        if (isSendToJPO) {
          event.preventDefault();
          event.returnValue = 'There is change(s) to Schedule. Please click on the "Send to JPO" button to send the latest schedules to JPO engine.';
          // console.log('isSendToJPO-window.onbeforeunload=========>', isSendToJPO)
          return '';
        }
      };
      this.showLoading();
      getWorkListData();
      getTeamScheduleData();
    },
    oncreate: (vnode) => {
    },
    onupdate: (vnode) => {
      // Enable multiple columns selection
      selectableTable();
    },
    onbeforeremove: (vnode) => {
      // console.log('isSendToJPO=========>', isSendToJPO)
      if (isSendToJPO) {
        if (confirm('There is change(s) to JPO Schedule. Please go back to "Team Schedule" page and click on the "Send to JPO" button to send the latest schedules to JPO engine.')) {
          return Promise.resolve();
        }
        else {
          return Promise.reject();
        }
      }
      return Promise.resolve();
    },
    onremove: function (vnode) {
      window.onbeforeunload = null;
    },
    view: (vnode) => {
      return [
        m('.row',
          m('.col-12',
            isOpenScheduleDetails &&
            m('.container-lg',
              m('.d-flex.justify-content-end.mb-3',
                m('.buttons-wrapper',
                  scheduleUserDetails && scheduleUserDetails.userAccess && scheduleUserDetails.userAccess.jpoUser && m(Button, {
                    style: { "margin-right": '10px' },
                    label: [m('i.bi.bi-send'), this.getText("LT00008148", "Send to JPO")],
                    intent: Intent.POSITIVE,
                    onclick: getLatestJPOSchedule
                  }),
                  m(Button, {
                    label: this.getText("LT00000021", "Close"),
                    intent: Intent.PRIMARY,
                    onclick: hideScheduleDetails,
                  }),
                ),
              ),
            ),
            !isOpenScheduleDetails &&
            [
              m('.card.mb-3',
                m('.card-body',
                  m('.row.g-4.align-items-end',
                    m('.col-md-4',
                      m('label.form-label', this.getText("LT00000070", "Date Range")),
                      m(DatePickerComponent, {
                        class: 'form-control',
                        isRange: true,
                        dateStart: fromDate, // default date range
                        dateEnd: toDate, // default date range
                        readonly: true,
                        onselect: (e) => {
                          fromDate = moment(e.detail.start).format(FORMATS.dateFormat);
                          toDate = moment(e.detail.end).format(FORMATS.dateFormat);
                        }
                      })
                    ),
                    m('.col-md-4',
                      m('label.form-label', this.getText("LT00000149", "Work Type")),
                      workTypeColorList &&
                      m(MultiSelectComponent, {
                        items: workTypeOptionList,
                        selectedItems: selectedWorkTypeList,
                        itemIcons: workTypeIconElementList,
                        keyOnly: true,
                        onSelect: (selectedOptions) => {
                          selectedWorkTypeList = selectedOptions;
                        }
                      })
                    ),
                    m('.col-md-4.text-end.text-md-start',
                      m(Button, {
                        label: [m('i.bi.bi-search'), this.getText("LT00000001", "Search")],
                        intent: Intent.PRIMARY,
                        onclick: reloadData
                      })
                    ),
                  ),
                )
              ),
              m('.card',
                m('.card-body',
                  m('.d-flex.justify-content-between.align-items-end.mb-2', { style: 'gap: 1.5em;' },
                    m('.worktype-legend.d-flex.flex-wrap.ps-1', { style: 'gap: 1.25em;' }, [
                      workTypeColorList &&
                      workTypeList.filter(e => e.color).map(wt =>
                        m('label', { style: 'white-space: nowrap;' },
                          m('.work-type-indicator', {
                            style: {
                              'border-color': wt.color,
                              'background-color': wt.color,
                            }
                          }),
                          wt.name
                        ),
                      ),
                    ]),
                    m("div", [userScheduleAccess.some(obj => obj.jpoUser === true) && m(Button, {
                      style: { "margin-right": '10px' },
                      label: [m('i.bi.bi-send'), this.getText("LT00008148", "Send to JPO")],
                      intent: Intent.POSITIVE,
                      onclick: getLatestJPOSchedule
                    }), 
                    m(Button, {
                      style: { "margin-right": '10px' },
                      label: [m('i.bi.bi-upload'), this.getText("LT00001342", "Simple Excel Upload")],
                      intent: Intent.PRIMARY,
                      onclick: () => { showScheduleExcelUpload(true) }
                    }), 
                    m(Button, {
                      style: { "margin-right": '10px' },
                      label: [m('i.bi.bi-file-earmark-arrow-up-fill'), this.getText("LT00000197", "Excel Upload")],
                      intent: Intent.PRIMARY,
                      onclick: () => { showScheduleExcelUpload(false) }
                    }), m(Button, {
                      label: [m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download")],
                      intent: Intent.PRIMARY,
                      onclick: handelScheduleExcelDownload
                    })
                    ])
                  ),
                  dayColumns && dayColumns.length > 0 &&
                  m('.row',
                    m(".col-12.p-0",
                      m('.table-responsive',
                        m('table.table.team-schedule',
                          m('thead',
                            m('tr.align-middle',
                              m('th', { 'scope': 'col', 'style': 'min-width: 160px; width: 200px;' }, this.getText("LT00000198", "Team Members")),
                              dayColumns.map((day) => [
                                m('th.text-center', {
                                  'scope': 'col', 'style': 'min-width: 160px; width: 600px; cursor: pointer', onclick: () => {
                                    getBUTypes(moment(day).format(FORMATS.dateFormat))
                                  }
                                }, day.format(DATE_FORMAT_TABLE_HEADER)),
                              ]),
                            ),
                          ),
                          m('tbody',
                            !(scheduleTable && scheduleTable.length > 0) &&
                            m('tr.align-middle',
                              m('td', { 'colspan': '9' }, this.getText("EM00000141", "No records found."))
                            ),
                            scheduleTable && scheduleTable.length > 0 &&
                            scheduleTable.map((row, rowId) => [
                              m('tr',
                                m('th',
                                  { 'scope': 'row', 'style': 'white-space: normal; max-width: 240px;' },
                                  m(UserBadgeComponent,
                                    {
                                      image: row.photoString,
                                      imageSize: '40px',
                                      flexGap: '0.5rem'
                                    },
                                    m('span', { style: 'font-size: 0.875rem; word-break: break-word;' }, row.userName)
                                  ),
                                ),
                                row.dateCols.map((col, colId) => [
                                  m('td.schedule-col.align-top.user-select-none', {
                                    class: isTodayOrFutureDate(dayColumns[colId]) ? 'editable' : 'uneditable',
                                    'scope': 'col',
                                    'data-row-id': rowId,
                                    'data-col-id': colId,
                                  },
                                    Array.isArray(col) && col.some(item => (item.createUserId === "JPO" || item.createUserId === "JPOM")) &&
                                    m(Tooltip, {
                                      content: "Check routing plan",
                                      hoverOpenDelay: 250,
                                      openOnTriggerFocus: true,
                                      position: PopoverPosition.RIGHT,
                                      trigger: m('button.btn.btn-link.btn-assign2', {
                                        onclick: () => {
                                          const itemOne = col[0];
                                          onRoutePlanDetailsView(itemOne);
                                        }
                                      },
                                        m('i.bi.bi-calendar-check')
                                      ),
                                    }),
                                    isTodayOrFutureDate(dayColumns[colId]) &&
                                    m(Popover, {
                                      content: m(AssignScheduleView, {
                                        scheduleUserDetails: scheduleUserDetails,
                                        onClose: (o) => {
                                          hideAssignSchedule();
                                          clearTableSelection();
                                        },
                                        triggerRefresh: (needRefresh, j) => {
                                          // console.log('AssignScheduleView needRefresh===========>', needRefresh)
                                          // console.log('AssignScheduleView isSendToJPO===========>', isSendToJPO)

                                          isSendToJPO = j;
                                          if (needRefresh) {
                                            reloadData();
                                          }
                                        },
                                      }),
                                      position: PopoverPosition.AUTO,
                                      onInteraction: (nextOpenstate) => nextOpenstate ? showAssignSchedule(colId, rowId) : hideAssignSchedule,
                                      isOpen: isAssignScheduleOpen(colId, rowId),
                                      trigger: m('button.btn.btn-link.btn-assign', {
                                        onclick: () => setSelectedSchedule(row.userID, row.userName, row.photoString, dayColumns[colId].format(FORMATS.dateFormat))
                                      },
                                        m('i.bi.bi-plus-circle')
                                      )
                                    }),
                                    col &&
                                    col.map((colSchedule) => [
                                      colSchedule &&
                                      m(TableScheduleItem, {
                                        col: colSchedule,
                                        userId: colSchedule.userID,
                                        userName: colSchedule.userName,
                                        photoString: colSchedule.photoString,
                                        scheduleDate: colSchedule.scheduleDate,
                                        scheduleNameDisplay: colSchedule.scheduleNameDisplay,
                                        startTime: colSchedule.startTime,
                                        startEndTime: `${colSchedule.startTime} ~ ${colSchedule.endTime}`,
                                        workType: colSchedule.workType,
                                        createUserId: colSchedule.createUserId
                                      })
                                    ]),
                                  ),
                                ]),
                              ),
                            ]),
                          ),
                        )
                      ),
                    )
                  )
                )
              )
            ],
            isOpenScheduleDetails &&
            m(ScheduleDetailsView, {
              setSendToJPO: setSendToJPO,
              triggerRefresh: (needRefresh) => {
                // isSendToJPO = j;
                // console.log('ScheduleDetailsView isSendToJPO=========>', j)
                // console.log('ScheduleDetailsView needRefresh=========>', needRefresh)
                if (needRefresh) {
                  reloadData();
                }
              },
              scheduleUserDetails: scheduleUserDetails,
            }),
            isOpenScheduleExcelUpload &&
            m(Dialog, {
              class: 'cui-dialog-l modal-body-overflow-visible',
              closeOnOutsideClick: false,
              isOpen: isOpenScheduleExcelUpload,
              onClose: hideScheduleExcelUpload,
              title: isSimpleExcelUpload ? this.getText('LT00001342', 'Simple Excel Upload') : this.getText('LT00000199', 'Schedule Excel Upload'),
              content: m(ScheduleExcelUploadView, {
                onClose: (o) => { isOpenScheduleExcelUpload = o; },
                triggerRefresh: (needRefresh) => {
                  if (needRefresh) {
                    reloadData();
                  }
                },
                isSimpleUpload: isSimpleExcelUpload,
              }),
            }),
            showDetails && m(Dialog, {
              isOpen: showDetails,
              onClose: () => { showDetails = false; selectedItem = {}; },
              closeOnOutsideClick: false,
              transitionDuration: 200,
              title: `${this.getText("LT00001311", "Calendar")} - ${selectedItem?.userName}`,
              content: m(JPOScheduleCalendarView, selectedItem),
              "class": "jpo-dialog"
            }),
            showSendToJPOResult && m(Dialog, {
              isOpen: showSendToJPOResult,
              onClose: () => { showSendToJPOResult = false },
              closeOnOutsideClick: false,
              transitionDuration: 200,
              title: "Sent to JPO Result",
              content: m(SendToJPOResultView, { onClose: () => { showSendToJPOResult = false }, JPOresult: JPOresult }),
            }),
          )
        ),
        this.getBaseViews()
      ]
    }
  }

}